import { render, staticRenderFns } from "./RuleDetail.vue?vue&type=template&id=598824e1&"
import script from "./RuleDetail.vue?vue&type=script&lang=ts&"
export * from "./RuleDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports